function mouseOver(e: any) {
	const bet = e.currentTarget.getAttribute("bet");
	this.setState({activeHover: bet});
}
	
function mouseLeave() {
	this.setState({activeHover: ""});
}
	
function handleTouchDown(e: any) {
	//Gets scroll pos
	this.lastScroll = window.scrollY;
	this.lastPress = Date.now();
	
	const pcode = e.currentTarget.getAttribute("pcode");
	// console.log("hbp", pcode);
	this.activeHover = pcode;
	this.setState({activeHover: pcode});
}
	
function handleTouchRelease(e: any) {
	const timeSpan = Date.now() - this.lastPress;
	const scrollDistance = Math.abs(this.lastScroll - window.scrollY);
	
	const group = e.currentTarget.getAttribute("group");
	
	// console.log("group", group);
	
	if (this.lastPress !== undefined)
		if (timeSpan < 200)
			// Adds scroll tolerance
			if (scrollDistance < this.scrollClickTolerance)
				console.log("open group", group);
	
	this.activeHover = "";
	this.setState({activeHover: ""});
}

export {mouseOver, mouseLeave, handleTouchDown, handleTouchRelease};
